import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderStatus } from 'common/model/OrderStatus';
import { orderStatusDot } from '../OrderList.types';

interface StatusFilterTabsProps {
  statusFilter: string;
  statusCounts: Record<string, number> | undefined;
  onStatusFilterChange: (status: string) => void;
}

export const StatusFilterTabs = ({
  statusFilter,
  statusCounts,
  onStatusFilterChange,
}: StatusFilterTabsProps) => {
  const { t } = useTranslation();

  return (
    <Grid
      component={Paper}
      justifyContent="space-between"
      alignItems="center"
      sx={{ borderRadius: 0 }}
      container
    >
      <Tabs
        value={statusFilter}
        onChange={(_, newValue) => onStatusFilterChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
      >
        {Object.values(OrderStatus).map((status) => (
          <Tab
            key={status}
            sx={{ p: 1 }}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 0 }}>
                {orderStatusDot(status)}
                <span>
                  {t(`orderStatus.${status}`)} (
                  {status === 'on_way'
                    ? statusCounts?.onWay || 0
                    : statusCounts?.[status as keyof typeof statusCounts] || 0}
                  )
                </span>
              </Box>
            }
            value={status}
          />
        ))}
      </Tabs>
    </Grid>
  );
};
